/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
  color?: string;
};

const SvgPillBottleIcon: FC<IProps> = ({ width = 24, height = 24, color = "#262626" }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18 11.0863H14C13.7348 11.0863 13.4804 11.1917 13.2929 11.3792C13.1054 11.5667 13 11.8211 13 12.0863V17.0863C13 17.3515 13.1054 17.6059 13.2929 17.7934C13.4804 17.9809 13.7348 18.0863 14 18.0863H18M6 7.0863V20.0863C6 20.6167 6.21071 21.1254 6.58579 21.5005C6.96086 21.8756 7.46957 22.0863 8 22.0863H16C16.5304 22.0863 17.0391 21.8756 17.4142 21.5005C17.7893 21.1254 18 20.6167 18 20.0863V7.0863M5 2.0863H19C19.5523 2.0863 20 2.53402 20 3.0863V6.0863C20 6.63859 19.5523 7.0863 19 7.0863H5C4.44772 7.0863 4 6.63859 4 6.0863V3.0863C4 2.53402 4.44772 2.0863 5 2.0863Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgPillBottleIcon;
